import React from 'react';
import { useNavigate } from 'react-router-dom';

const PurchaseCancelPage = () => {
  const navigate = useNavigate();
  
  const handleReturnToProducts = () => {
    navigate('/purchase');
  };
  
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-800">Purchase Cancelled</h1>
          <p className="text-gray-600 mt-2">Your order has been cancelled and you have not been charged.</p>
        </div>
        
        <div className="text-center mb-8">
          <p>
            If you encountered any issues during the checkout process or have questions about our products, 
            please contact our support team at <a href="mailto:support@cretecinc.com" className="text-blue-600 hover:underline">support@cretecinc.com</a>.
          </p>
        </div>
        
        <div className="text-center">
          <button
            onClick={handleReturnToProducts}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700"
          >
            Return to Products
          </button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseCancelPage;